(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-slider"] && !Shopify.designMode) return;
  try {
    
  class QuoteSlider extends HTMLElement {
    /** How many copies of the cards sit either side of the real ones */
    copies = 2;

    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.cards = [...(this.track?.children || [])];
      if (!this.track || this.cards.length === 0) return;
      this.cards.forEach((card, index) => {
        card.dataset.tilt = String(index % 7);
        card.dataset.shape = String(index % 4);
      });

      this.querySelector('[ref="previous"]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[ref="next"]')?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('onscrollend' in window) this.track.addEventListener('scrollend', this.wrap);
      this.cards.forEach((card) => this.watchQuote(card));

      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.track);
      this.layout();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('scrollend', this.wrap);
      this.resizeObserver?.disconnect();
    }

    /** All the real cards fit across the track, so they can sit centred without scrolling */
    get fits() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const total = this.cards.reduce((sum, card) => sum + card.offsetWidth, 0) + gap * (this.cards.length - 1);
      return total <= this.track.clientWidth;
    }

    /** A few cards sit still in the middle; more than fit become a looping slider */
    layout() {
      const fits = this.cards.length < 2 || this.fits;
      if (fits !== this.isStatic) {
        this.isStatic = fits;
        this.classList.toggle('quote-slider--static', fits);
        if (fits) this.removeCopies();
        else this.addCopies();
      }
      this.track.querySelectorAll('.quote-card__quote').forEach((quote) => this.updateQuote(quote));
      if (!fits) this.centre(this.current ?? 0);
    }

    addCopies() {
      const copy = () =>
        this.cards.map((card) => {
          const clone = card.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.copy = '';
          clone.inert = true;
          this.watchQuote(clone);
          return clone;
        });
      for (let i = 0; i < this.copies; i++) {
        this.track.prepend(...copy());
        this.track.append(...copy());
      }
    }

    removeCopies() {
      this.track.querySelectorAll('[data-copy]').forEach((clone) => clone.remove());
      this.track.scrollLeft = 0;
    }

    /** Fades and the read more hint follow the quote's own scrolling */
    watchQuote(card) {
      const quote = card.querySelector('.quote-card__quote');
      if (!quote) return;
      quote.addEventListener('scroll', () => this.updateQuote(quote), { passive: true });
      card.querySelector('.quote-card__more')?.addEventListener('click', () =>
        quote.scrollBy({ top: quote.clientHeight * 0.7, behavior: 'smooth' })
      );
    }

    /** Marks whether a quote is longer than its card, and whether it is scrolled to either end */
    updateQuote(quote) {
      const paper = quote.parentElement;
      const scrollable = quote.scrollHeight > quote.clientHeight + 2;
      paper.classList.toggle('is-scrollable', scrollable);
      paper.classList.toggle('is-at-start', quote.scrollTop <= 2);
      paper.classList.toggle('is-at-end', quote.scrollTop + quote.clientHeight >= quote.scrollHeight - 2);
    }

    /** Scroll position that puts a card in the middle */
    position(card) {
      return card.offsetLeft + card.offsetWidth / 2 - this.track.clientWidth / 2;
    }

    get step() {
      return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
    }

    centre(index) {
      this.current = index;
      this.track.scrollLeft = this.position(this.cards[index]);
    }

    move(direction) {
      if (this.isStatic) return;
      this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }

    /** Browsers without scrollend: wrap once scrolling has been still for a moment */
    onScroll = () => {
      if (this.isStatic || 'onscrollend' in window) return;
      clearTimeout(this.settle);
      this.settle = setTimeout(this.wrap, 150);
    };

    /** Once scrolling settles in the copies, jump back to the same card in the real set */
    wrap = () => {
      if (this.isStatic) return;
      const start = this.position(this.cards[0]);
      const length = this.step * this.cards.length;
      let left = this.track.scrollLeft;
      if (left < start - this.step / 2) left += length;
      else if (left > start + length - this.step / 2) left -= length;
      if (Math.abs(left - this.track.scrollLeft) > 1) {
        // Snap off for the jump so it lands exactly, with no second snap animation
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft = left;
        requestAnimationFrame(() => (this.track.style.scrollSnapType = ''));
      }
      this.current = Math.round((left - start) / this.step);
    };
  }

  if (!customElements.get('quote-slider')) customElements.define('quote-slider', QuoteSlider);

  } catch(e) { console.error(e); }
})();
})();
